import { useMemo } from 'react'

// Serializes the input array into a comma-separated string and uses useMemo
// to return an array that only changes if the input content changes.
//
// Example usage:
// const stableArray = useStableStringArray(['banana', 'apple', 'pear'])

function useStableStringArray(array?: string[]): string[] {
  const serialized = array ? JSON.stringify(array) : ''

  return useMemo(() => {
    if (!serialized) return []
    return JSON.parse(serialized)
  }, [serialized])
}

export default useStableStringArray
